//this object records the participant data

const Data = {
  //the participant's Prolific ID
  prolificId: [],
  //the attention check during the instructions trial
  attnCheck: [],
  //the data for a training trial
  training: [],
  //the data describing a particular trial
  trialData: [],
  //our main DV
  responses: [],
  //the free-form comment 
  freeComment: [],
  //the answers to demographic questions
  demographics: []
};

export default Data;